import * as React from "react";
const ReactModal = require('react-modal');
const IconFacebook = require('!svg-react-loader?name=IconFacebook!../../wwwroot/img/icons/icon-facebook.svg');
const IconTwitter = require('!svg-react-loader?name=IconTwitter!../../wwwroot/img/icons/icon-twitter.svg');
const IconGoogle = require('!svg-react-loader?name=IconGoogle!../../wwwroot/img/icons/icon-google.svg');
const IconGlass = require('!svg-react-loader?name=IconGlass!../../wwwroot/img/logo-glass.svg');
const Icons = {
    IconFacebook: IconFacebook,
    IconTwitter: IconTwitter,
    IconGoogle: IconGoogle,
    IconGlass: IconGlass,
};
export default class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            if (this.props.toggle) {
                this.props.toggle();
            }
        };
        this.state = {
            modalOpen: false
        };
        this.customClasses = {
            afterOpen: 'afterOpen',
            base: 'base',
            beforeClose: 'beforeClose'
        };
        this.customOverlayClasses = {
            afterOpen: 'afterOpen',
            base: 'base',
            beforeClose: 'beforeClose'
        };
        this.customAriaVariables = {
            labelledby: 'labelledby',
            describedby: 'describedby'
        };
        let htmlSelector = document.querySelector('html');
        let loginProviders = htmlSelector.getAttribute('data-login-providers');
        this.loginProviders = JSON.parse(loginProviders);
        // using JSON.parse() because it'll convert the string from the attribute to a boolean
        this.authenticated = JSON.parse(htmlSelector.getAttribute('data-authenticated'));
        this.antiForgery = htmlSelector.getAttribute('data-antiforgery');
    }
    render() {
        return (React.createElement(ReactModal, { isOpen: this.props.modalOpen || false, onRequestClose: this.toggle, contentLabel: "demo label", style: this.customStyle, className: {
                base: 'signin-modal__content',
                afterOpen: 'signin-modal__content_after-open',
                beforeClose: 'signin-modal__content_before-close'
            }, overlayClassName: {
                base: 'signin-modal__overlay',
                afterOpen: 'signin-modal__overlay_after-open',
                beforeClose: 'signin-modal__overlay_before-close'
            }, bodyOpenClassName: 'bodyOpenClassName', aria: this.customAriaVariables },
            React.createElement("h2", null, "Sign in to create your shopping list"),
            React.createElement("p", null, "Create an account to add your favourite products to your shopping list! Your shopping list will be available wherever you go, whether on your computer or on your phone."),
            React.createElement("p", null, "Click one of the social media login buttons below to begin."),
            React.createElement("form", { action: "/Account/ExternalLogin", method: "post" },
                React.createElement("div", { className: "btn-login-wrap" }, this.loginProviders.map((value, index) => {
                    let providerName = value.Name;
                    let iconName = 'Icon' + providerName;
                    let IconComponent = Icons[iconName];
                    let iconClass = providerName.toLowerCase();
                    if (IconComponent) {
                        //ensure the login has an icon as otherwise crashes popup
                        return React.createElement("button", { type: "submit", name: "provider", value: providerName, className: "btn " + iconClass, key: index },
                            React.createElement(IconComponent, null));
                    }
                })),
                this.props.fromHeader ? React.createElement("div", { className: "btn-login-wrap__liquorconnect" },
                    React.createElement("a", { href: "https://portal.liquorconnect.com/_layouts/15/Login.aspx?Source=%2FPages%2Fdefault%2Easpx", className: "btn" },
                        React.createElement(IconGlass, null),
                        " Liquor Connect Client Sign In")) : null,
                React.createElement("input", { name: "__RequestVerificationToken", type: "hidden", value: this.antiForgery }))));
    }
}
;
//# sourceMappingURL=sign-in.js.map